import gql from 'graphql-tag'

export default gql`
  query SelectCourse {
    courses(perPage: 100) {
      nodes {
        id
        title
      }
    }
  }
`
